export const getAlertObject = (state) => state.alertObject;
export const getMetricAlerts = (state) => state.metricAlertItems;
export const getSystemAlerts = (state) => state.systemAlertItems;
export const getAlertModalStatus = (state) => state.alertModalStatus;
